import { render, staticRenderFns } from "./importFile.vue?vue&type=template&id=9a96ede4&"
import script from "./importFile.vue?vue&type=script&lang=js&"
export * from "./importFile.vue?vue&type=script&lang=js&"
import style0 from "./importFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports